import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export const useDeleteMember = (successCallback?: () => void): UseMutationResult<null, Error, { id: number }, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, { id: number }>({
        mutationFn: async ({ id }: { id: number }) => {
            const response = await axios.delete(`${enum_api_uri.delete_member}/${id}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getMemberList"] });
            successCallback?.();
        },
    });
};
